import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'

const usePageTracking = () => {
  const location = useLocation()

  useEffect(() => {
    const consent = Cookies.get("cookieConsent")
    if (!consent) return // bez souhlasu se nic nespustí

    if (window.gtag) {
      window.gtag("config", 'G-RFM77PEWVY', {
        page_path: location.pathname,
      })
    }
  }, [location])
}

export default usePageTracking